import axios from 'axios';
import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { Label } from 'reactstrap'
import { environment } from '../../env';
import { successModalToggle, loaderAction, getQueryAction } from '../../redux/actions/Index';
import ErrorComponents from '../errorComponents/ErrorComponents';
import TitleCase from '../../Helper/TitleCase'
import { PencilLine } from '@phosphor-icons/react';
import { useEffect } from 'react';
function EditQuery({ query, usersListProp }, ...props) {
    const [modal, setModal] = useState(false);
    const [btndis, setBtndis] = useState(false)
    const [users, setUsers] = useState([])
    const toggle = () => { setModal(!modal) }
    const dispatch = useDispatch()
    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm();

    const getQueryData = () => {
        try {
            axios.get(`${environment.baseUrl}query`).then(res => {
                let data = res.data;
                dispatch(getQueryAction(data));
            }).catch(res => {
                console.log("error", res);
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    // const getAllUser = async () => {
    //     try {
    //         axios.get(`${environment.baseUrl}registration/`).then(res => setUsers(res.data));
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }
    const onSubmit = async (data) => {
        setBtndis(true);
        dispatch(loaderAction(true))
        try {
            await axios.put(`${environment.baseUrl}edit-query/${query.id}`, data).then((form) => {
                if (form.data.code === 200) {
                    dispatch(successModalToggle());
                    getQueryData();
                    dispatch(loaderAction(false))
                    setBtndis(false);
                    toggle();
                    reset();
                } else {
                    setBtndis(false);
                    console.log("error")
                }
            })
        }
        catch (err) {
            setBtndis(false);
            dispatch(loaderAction(false))
            console.log(err);
        }
    };

    const CancelButton = () => {
        toggle();
        reset();
        setBtndis(false);
    }

    // useEffect(() => {
    //     getAllUser()
    //     reset({
    //         'assign': query.assign,
    //         'status': query.status
    //     })
    // }, [])

    return (
        <>

            <button
                onClick={toggle}
                className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' /></button>
            <Modal className='border-0' isOpen={modal} toggle={props.toggle} size="lg" centered>
                <ModalHeader className='bg-base-color ' ><span className='title-font-700 fs-36 text-base-white'>Edit Query</span></ModalHeader>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <ModalBody className='bg-background-color px-5'>
                        <div className="row">
                            <div className='col-6  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Assign To *
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <select id="project" name="assign" className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        {...register("assign", { required: true })}>
                                        <option value=''>Select Assign To</option>
                                        {
                                            usersListProp?.sort((a, b) => a?.first_name?.localeCompare(b?.first_name)).map((user, i) => <option value={user?.first_name + " " + user?.last_name} key={i}>{user?.first_name + " " + user?.last_name}</option>)
                                        }
                                    </select>
                                </div>
                                {errors.status && <ErrorComponents error={'Status is required *'} />}
                                <br />
                            </div>
                            <div className='col-6  pb-3 pt-1'>
                                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                    Status *
                                </Label>
                                <br />
                                <div className='mt-1  d-flex gap-3'>
                                    <select id="project" name="status" className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                        {...register("status", { required: true, onChange: (e) => { e.target.value } })}>
                                        <option value='' >Select Status</option>
                                        <option value={'Pending'} >Pending</option>
                                        <option value={'Complete'} >Complete</option>
                                    </select>
                                </div>
                                {errors.status && <ErrorComponents error={'Status is required *'} />}
                                <br />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>{' '}
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons' disabled={btndis}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Edit</span></Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </>
    )
};


export default EditQuery